import { styled, Box, Typography } from "@mui/material";

export const HeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "32px",
});

export const HeaderTitle = styled(Typography)({
  fontSize: "36px",
  fontWeight: 500,
});

export const BackButtonWrapper = styled(Box)({
  marginBottom: "15px",
  cursor: "pointer",
});
